export  default [

    {
        path: "/prospect",
        name: "prospect",
        component: () => import("./tab/List"),
        meta: {
            permiss:['PROSPECT_TASK_SHOW'],
            title: "现场勘察"
        }
    },
    {
        path: "/prospect/update",
        name: "prospectDetail",
        component: () => import("./Update"),
        meta: {
            title: "新增勘察任务"
        }
    },
    // {
    //     path: "/prospect/update/:id",
    //     name: "prospectDetail",
    //     component: () => import("./Update"),
    //     meta: {
    //         title: "修改勘察任务"
    //     }
    // },
    {
        path: "/prospect/detail/:id",
        name: "prospectDetail",
        component: () => import("./Detail"),
        meta: {
            title: "勘查项列表"
        }
    },
]